import React from 'react'
import { ToolbarItem } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { ToolbarSection } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { defaultProps } from './index'

export const RowSettings = (props) => {
  const directionOptions = [
    { label: 'Left-Right', value: '' },
    { label: 'Right-left', value: 'reverse' },
  ]
  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="direction"
          type="select"
          options={directionOptions}
          label="Direction"
          defaultValue={defaultProps['direction']}
        />
      </ToolbarSection>
    </>
  )
}
